import { Form } from 'antd';
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { GroupListComponents } from './GroupListComponents';

const GroupListComponentsForm: any = Form.create()(GroupListComponents);
interface Props extends RouteComponentProps<{ skuId: string }> {}
interface State {}
export class GroupList extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }
  render() {
    return <GroupListComponentsForm {...this.props} skuIds={this.props.match.params.skuId} />;
  }
}



// WEBPACK FOOTER //
// ./src/screens/group/GroupList.tsx